import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/app/api';
import { toast } from 'sonner';


export function useEnquieryForm () {
    const queryClient = useQueryClient();

    const {data,isPending} = useQuery({
        queryKey: ['enquiry'],
        queryFn: async () => {
            const response = await api.get('/enquiry');
            return response.data;
        },
    })

    

    const userEnquieryForm = useMutation({
        
        mutationFn: async (data: any) => {
            const response = await api.post('/enquiry', data);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['enquiry'] });
            toast.success('Inquiry submitted successfully');
        },
        onError: (error: any) => {
            toast.error(`Error submitting inquiry: ${error.message}`);
        }
    })

    const editEnquieryForm = useMutation({
        mutationFn: async ({id,data}:any ) => {
            const response = await api.patch(`/enquiry/${id}`, data);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['enquiry'] });
            toast.success('Inquiry updated successfully');
        },
        onError: (error: any) => {
            toast.error(`Error updating inquiry: ${error.message}`);
        }
    })

    const deleteEnquieryForm = useMutation({
        mutationFn: async (id: string) => {
            const response = await api.delete(`/enquiry/${id}`);
            return response.data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['enquiry'] });
            toast.success('Inquiry deleted successfully');
        },
        onError: (error: any) => {
            toast.error(`Error deleting inquiry: ${error.message}`);
        }
    })
    return {
        userEnquieryForm,
        data,
        isPending,
        editEnquieryForm,
        deleteEnquieryForm
    }
}




